<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Lịch sử truy cập</h2>
        <div>
          <!-- <el-button @click="updateCount" size="small" type="info" class="btn-create">Update Count</el-button> -->
          <!-- <el-button @click="createModel" size="small" type="info" class="btn-create">Thêm mới</el-button> -->
        </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-filter">
        <el-col :span="8">
          <el-date-picker
            v-model="filter.date"
            @change="changeDateStatistic"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="tới"
            start-placeholder="Ngày bắt đầu"
            end-placeholder="Ngày kết thúc">
          </el-date-picker>
        </el-col>
        <el-col :span="2">
          <el-switch
            v-model="searchCOD"
            active-text="HideMe"
            active-color="#13ce66"
            inactive-color="#7f8c8d"
            @change="changehideme()">
          </el-switch>
        </el-col>
        <el-col :span="2">
          <el-switch
            v-model="showFull"
            active-text="showFull"
            active-color="#13ce66"
            inactive-color="#7f8c8d">
          </el-switch>
        </el-col>
        <el-col :span="2">
          <el-popover
            placement="bottom"
            title="Sắp xếp theo"
            width="400"
            trigger="click"
            content="Nội dung">
            <div class="model-filter-radio"
              v-for="(item, index) in sort"
              :key="index">
              <span>{{ item.groupName }}:</span>
              <el-radio
                v-for="(itemSort, index_itemSort) in item.groupFiled"
                :key="index_itemSort"
                v-model="filter.sort" :label="itemSort.label">{{ itemSort.text }}</el-radio>
            </div>
            <span class="model-filter-search" slot="reference">
              <i class="fas fa-sort"></i>
            </span>
          </el-popover>
        </el-col>
        <el-col :span="4"></el-col>
        <el-col :span="5">
          <el-input
            placeholder="Tìm kiếm ..."
            class="input-seach"
            clearable
            :prefix-icon="searching ? 'fas fa-spinner fa-spin' : 'el-icon-search'"
            v-model="filter.q">
          </el-input>
        </el-col>
      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="table.pagination.per_page"
            :pager-count="table.pagination.count"
            :current-page="table.pagination.current_page"
            :total="table.pagination.total"
            @current-change="changeCurrentPage">
          </el-pagination>
          <div>
            Hiển thị tới Lịch sử truy cập <strong>{{ table.meta_pagination }}</strong> / Tổng số: <strong>{{ table.pagination.total }}</strong> Lịch sử truy cập / Tổng: {{ this.total_lessons }} Lịch sử truy cập
          </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table
          v-loading="loading"
          border
          :data="table.database"
          style="width: 100%">
          <el-table-column
            label="#"
            type="index"
            width="40">
          </el-table-column>
          <el-table-column
            width="160"
            label="Thời gian">
            <template slot-scope="scope">
              <div class="courses-info">
                  <span style="font-size: 16px">{{ scope.row.created_at }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="ip"
            width="135"
            align="center"
            label="Địa chỉ IP">
            <template slot-scope="scope">
                <span style="font-size: 15px">{{ scope.row.ip }} </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="ip_name"
            width="135"
            align="center"
            label="Tên IP">
            <template slot-scope="scope">
                <span>{{ scope.row.ip_name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Thông tin">
            <template slot-scope="scope">
              <div class="courses-info">
                  <span style="font-size: 15px; color: green">{{ scope.row.url_path }}</span>
                  <span v-if="showFull" style="font-size: 12px">{{ scope.row.url_full }}</span>
                  <span v-if="showFull" style="font-size: 12px">{{ scope.row.url_previous }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="route_name"
            align="center"
            width="200"
            label="Tên Route">
            <template slot-scope="scope">
                <span style="font-weight: bold; color: green">{{ scope.row.route_name }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'Item',
  metaInfo () {
    return {
      title: 'Lịch sử truy cập'
    }
  },
  data () {
    return {
      loading: false,
      searching: false,
      total_lessons: 0,
      searchCOD: true,
      showFull: false,
      filter: {
        q: '',
        status: '',
        hideme: true,
        date: '',
        hot: '',
        daterange: '',
        page: 1,
        limit: 25,
        sort: '',
        include: ''
      },
      sort: [
        {
          groupName: 'Không sắp xếp',
          groupFiled: [
            { label: '', text: 'Không sắp xếp' }
          ]
        },
        {
          groupName: 'Địa chỉ IP',
          groupFiled: [
            { label: 'ip:-1', text: 'Tăng dần' },
            { label: 'ip:1', text: 'Giảm dần' }
          ]
        },
        {
          groupName: 'Tên Path',
          groupFiled: [
            { label: 'url_path:1', text: 'Tăng dần' },
            { label: 'url_path:-1', text: 'Giảm dần' }
          ]
        }
      ],
      lists: {
        listStatus: [
          {key: 1, value: 'Kích hoạt'},
          {key: 0, value: 'Chưa kích hoạt'}
        ],
        listHot: [
          {key: 1, value: 'Nổi bật'},
          {key: 0, value: 'Bình thường'}
        ],
        listCategoryCourse: [
          {key: 0, value: 'Chọn lĩnh vực'}
        ],
        listTeacher: [
          {key: 0, value: 'Chọn giảng viên'}
        ]
      },
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        },
        timer: {}
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchDatabaseModel()
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'logs-index', text: 'Lịch sử truy cập' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút tạo Model
    createModel () {
      this.$router.push({name: 'logs-create'})
    },
    updateCount () {
      this.loading = true
      axios.post('logs/update-view-old').then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            this.fetchDatabaseModel()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    changehideme () {
      if (this.searchCOD) {
        this.filter.hideme = 1
      } else {
        this.filter.hideme = null
      }
      this.fetchDatabaseModel()
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true
      axios.get('logs', {params: this.filter}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về lĩnh vực Lịch sử truy cập
    fetchListCategoryCourse () {
      axios.get('category-courses', {params: {'status': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listCategoryCourse = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về giảng viên
    fetchListTeacher () {
      axios.get('users', {params: {'status': 1, 'system_manager': 0, 'user_type': 2}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listTeacher = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // Xem chi tiết
    showModel (model) {
      this.$router.push({name: 'logs-show', params: {course_id: model.id}})
    },
    updateModel (model) {
      this.$router.push({name: 'logs-update', params: {course_id: model.id}})
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus (model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.post('logs/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeHot (model) {
      let dataUpdate = {
        'hot': model.hot
      }
      axios.post('logs/update-hot/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa Lịch sử truy cập: ' + model.title, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('logs/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal (model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    },
    // Thay đổi Current Page
    changeCurrentPage (currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    },
    changeDateStatistic () {
      this.fetchDatabaseModel()
    },
    handleSuccess (e) {
      this.$notify({
        title: 'Thành công',
        message: 'Copy nội dung thành công',
        type: 'success',
        duration: 1000
      })
    },
    handleError (e) {

    }
  },
  watch: {
    'filter.status': function () {
      this.fetchDatabaseModel()
    },
    'filter.hot': function () {
      this.fetchDatabaseModel()
    },
    'filter.category_course_id': function () {
      this.fetchDatabaseModel()
    },
    'filter.teacher_id': function () {
      this.fetchDatabaseModel()
    },
    'filter.q': function () {
      this.searching = true
      clearTimeout(this.timer)
      let _this = this
      this.timer = setTimeout(function () {
        _this.searching = false
        _this.fetchDatabaseModel()
      }, 800)
    },
    'filter.sort': function () {
      this.fetchDatabaseModel()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-filter-search {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.model-filter-radio {
  margin-bottom: 10px;
}
.model-filter-radio span {
  margin-right: 20px;
  width: 135px;
  display: inline-block;
}
.course-image {
  width: 65px;
  border-radius: 2px;
  cursor: pointer;
}
.courses-info {
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.courses-info span {
  margin-bottom: 5px;
  cursor: pointer;
}
.el-date-editor {
  height: 33px;
  padding-top: 2px;
}
.el-range-editor .el-range-input {
  font-size: 13px;
}
.el-date-editor .el-range-separator {
  line-height: 27px !important;
}
</style>

<style type="text/css">
  .el-input--prefix .el-input__inner {
    height: 32px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/logs/Index.vue